import React, { useState } from 'react';
import {
  Button,
  useApi,
  Card,
  CardSection,
  CardFooter,
  CondensedMedium,
  Layout,
  CardHeader,
  SectionHeader,
  AxiomLogo,
  LayoutItem,
} from '@axiom/ui';
import { useNavigate, useSearchParams } from 'react-router';

import { UsersApi } from '../../api/users-api';
import { TermsApi } from '../../api/terms-api';

import { TermsOfUseContents } from './TermsOfUseContents';

export const TermsOfUse = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const relayState = searchParams.get('RelayState');
  const navigateUri = `/sso${relayState?.length ? `?RelayState=${relayState}` : ''}`;

  const [{ data: user }, terms] = useApi(
    UsersApi.readCurrentUser(),
    TermsApi.readTerms()
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAgreeAndSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    return UsersApi.updateUser({
      id: user.id,
      termsAndConditionsAcceptedAt: new Date().toISOString(),
    })
      .then(() => {
        void navigate(navigateUri);
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Layout direction="vertical">
      <LayoutItem position="center" verticalGutter="16px">
        <AxiomLogo />
      </LayoutItem>

      <Card name="TERMS_CARD" scrollable>
        <CardHeader>
          <SectionHeader>Terms of Use</SectionHeader>
        </CardHeader>
        <CardSection divider>
          {terms ? (
            <div dangerouslySetInnerHTML={{ __html: terms }} />
          ) : (
            <TermsOfUseContents />
          )}
        </CardSection>
        <CardFooter stackableOn="smallScreen">
          <Layout position="left middle" horizontalGutter="8px">
            <CondensedMedium name="TERMS_DISCLAIMER">
              By clicking on <strong>Agree and Submit</strong> you acknowledge
              that you have read and agree to the Axiom{' '}
              <a
                href="https://www.axiomlaw.com/axiom-terms-of-use"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Use
              </a>{' '}
              and{' '}
              <a
                href="https://www.axiomlaw.com/privacy-notice"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Notice
              </a>
              .
            </CondensedMedium>
          </Layout>
          <Button
            name="AGREE_SUBMIT_BUTTON"
            type="submit"
            disabled={isSubmitting}
            onClick={async e => {
              e.preventDefault();
              return handleAgreeAndSubmit();
            }}
          >
            Agree and Submit
          </Button>
        </CardFooter>
      </Card>
    </Layout>
  );
};
